import React, {useContext, useState} from 'react'
import {ReservationCalendarMainContext} from '../../../../context/ReservationCalendarMain'
import moment from 'moment'

function isDateSelected(day, value) {
  return value.isSame(day, 'day')
}

function beforeToday(day) {
  return day.isBefore(new Date(), 'day')
}

const beforeMonth = (day, value) => {
  let lastDate = new Date(value)
  lastDate.setDate(1)
  return day.isBefore(lastDate, 'day')
}

const afterMonth = (day, value) => {
  let lastDay = new Date(new Date().getFullYear(), new Date(value).getMonth() + 1, 0)
  return day.isAfter(lastDay, 'day')
}

function isToday(day) {
  return day.isSame(new Date(), 'day')
}

export default function StylingCalendar(day, value) {
  const {calendarView} = useContext(ReservationCalendarMainContext)

  if (isDateSelected(day, value)) return 'selected'
  if (beforeMonth(day, value)) return 'before'
  if (afterMonth(day, value) && calendarView !== 'reservation') return 'before'
  if (isToday(day)) return 'today'
  if (beforeToday(day) && calendarView === 'reservation') return 'before'
  return ''
}
